import { Plugins, platform } from '@/plugins/native-app/capacitor'
import store from '@/store'

if (Plugins && platform === 'ios') {
  // Don't hide the "done/close" keyboard bar on iOS
  const { Keyboard } = Plugins
  Keyboard.setAccessoryBarVisible({ isVisible: true })

  Keyboard.addListener('keyboardWillShow', () => {
    store.commit('device/setNativeKeyboardVisible', true)
  })

  Keyboard.addListener('keyboardWillHide', () => {
    store.commit('device/setNativeKeyboardVisible', false)
  })
}
